import { getChannels } from '@/api/channels'
import { ChannelState, RootState } from '@/types/store'
import { ActionContext, ActionTree } from 'vuex'

type Context = ActionContext<ChannelState, RootState>

export interface ChannelActions extends ActionTree<ChannelState, RootState> {
  getChannels: (ctx: Context) => Promise<void>
}

export const actions: ChannelActions = {
  async getChannels({ commit }): Promise<void> {
    commit('setIsChannelLoading', true)
    const channels = await getChannels()
    commit('setIsChannelLoading', false)
    commit('channelLoaded', channels)
  },
}
